/**
 * @desc 详情列表
 */
const URL = "/rantion-crawler";
import http, { updateResponse } from "@/http";
export function request(crawlerId: string | number, options?: any) {
  return updateResponse(
    http(URL + `/crawlerTask/list/${crawlerId}`, {
      method: "GET",

      ...options,
    }),
  );
}
